import { styled } from "styled-components";

export const PurchasedContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 18px;

  width: 600px;
  border: 1px solid #383838;
  border-radius: 30px;
  padding: 24px;
`;
